import { render, staticRenderFns } from "./ingressos.vue?vue&type=template&id=55e0c223"
import script from "./ingressos.vue?vue&type=script&lang=js"
export * from "./ingressos.vue?vue&type=script&lang=js"
import style0 from "./ingressos.vue?vue&type=style&index=0&id=55e0c223&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports